<template>
  <div class="flow-container">
    <div class="title">配额管理</div>
    <el-card style="margin-top:10px">
      <el-form :model="chooseKeyForm"
               :rules="chooseKeyFormRules"
               inline
               ref="chooseKeyFormRef">
        <el-form-item label="服务平台"
                      prop="platform">
          <el-select v-model="platform"
                     placeholder="请选择要查询的服务平台"
                     @change="updateKeyList">
            <el-option  v-for="item in platformList"
                        :key="item.code"
                        :label="item.name"
                        :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="key"
                      prop="key">
          <el-select v-model="chooseKeyForm.key"
                     placeholder="请选择要查询的key"
                     style="width:400px"
                     @change="getFlowData">
            <el-option v-for="item in keyOptionList"
                       :key="item.key"
                       :label="item.keyName+'//'+item.key"
                       :value="item.key"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-table :data="flowData"
                v-loading="loading"
                style="width: 100%">
        <el-table-column prop="platformName"
                         label="服务平台">
        </el-table-column>
        <el-table-column prop="alias"
                         label="服务">
        </el-table-column>
        <el-table-column prop="todayDose"
                         label="今日调用量">
        </el-table-column>
        <el-table-column prop="doseTop"
                         label="调用量上限（次/日）">
        </el-table-column>
        <el-table-column prop="dosePercent"
                         label="今日调用量百分比">
          <template slot-scope="scope">
            <div style="width:100%">
              <el-progress :percentage="scope.row.dosePercent<=100 ?scope.row.dosePercent:100"
                           text-inside
                           :stroke-width="20"
                           :format="getPercentText(scope.row.dosePercent)"
                           :color="getColor(scope.row.dosePercent)"></el-progress>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="maxQps"
                         width="170"
                         label="今日最大QPS（次/秒）">
        </el-table-column>
        <el-table-column prop="qpsTop"
                         label="QPS上限">
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>

import http from '@/http/index.js'
import queryKey from '../mixins/queryKey.js'
export default {
  mixins: [queryKey],
  data() {
    return {
      chooseKeyForm: {
        key: null
      },
      loading: false,
      chooseKeyFormRules: {
        key: [{ required: true, message: '请选择Key', trigger: 'blur' }]
      },
      flowData: null
    };
  },
  methods: {
    async getFlowData() {
      this.loading = true
      const res = await http.flow.config(this.chooseKeyForm);
      this.loading = false
      this.flowData = res;
    },
    getPercentText(percentage) {
      if (percentage < 100) {
        return () => {
          return percentage + '%';
        };
      } else {
        return () => {
          return percentage + '%' + '已超额';
        };
      }
    },
    getColor(percentage) {
      if (percentage < 100) {
        return '#18A6D3';
      } else if (percentage === 100) {
        return '#67C23A';
      } else {
        return '#F56C6C';
      }
    },
    updateKeyList() {
      this.keyOptionList = this.oriKeyList.filter(item => {
        return item.platformName === this.platform
      });
      if (this.chooseKeyForm && this.chooseKeyForm.key) {
        this.chooseKeyForm.key = null
      }
    }
  },

  async mounted() {
    if (JSON.stringify(this.$route.query) !== '{}') {
      this.platform = this.$route.query.platform;
      this.chooseKeyForm.key = this.$route.query.key;
      this.getFlowData();
    }
  }

};
</script>

<style lang="less" scoped>
.title {
  font-family: PingFangSC-Semibold;
  font-size: 18px;
  color: rgba(0, 0, 0, 1);
  font-weight: 500;
  line-height: 32px;
}
/deep/ table {
  border-spacing: 0px 1px !important;
}
// /deep/.el-table .cell {
//   word-break: normal !important;
// }
</style>
